import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'general', redirectTo: 'course', pathMatch: 'full' },
  { path: '', redirectTo: 'course', pathMatch: 'full' },
  { path: 'course', loadChildren: './course/course.module#CourseModule' },
  { path: 'onsite-lector', loadChildren: './onsite-lector/onsite-lector.module#OnsiteLectorModule' },
  //   { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top', // Add options right here
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
